<template>
  <div
    :id="`contract-template-history-row-${index}`"
    class="history-container border row bg-light py-4 pl-2 pr-3 my-3"
  >
    <div class="container-fluid row col-12 mx-1 pr-1">
      <div class="col margin-5" :class="!isMobile && 'vertical-divider'">
        <div class="row">
          <div class="col-12">
            <span class="data-title d-block border-mobile">
              Fecha de Modificación:
            </span>
            <span class="font-16 color-black">
              {{ item.dateOfAction | date }}
            </span>
            <br />
            <span class="font-16 color-black">
              {{ item.dateOfAction | hour }}
            </span>
          </div>
          <div class="col-12 mt-4">
            <span class="data-title d-block border-mobile">
              Modificado por:
            </span>
            <span class="font-16 color-black">
              {{ item.actionUser | empty }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-10">
        <div class="row pr-1 ml-0">
          <label class="data-title border-mobile">
            Modificación Ejecutada:
          </label>
          <div class="container-wrapper col-12">
            <div
              class="col-8 message-container pt-3 mb-3 pl-0 font-16"
              :class="HTMLDynamicClass({ item, index })"
              v-html="item.message ? item.message : '-'"
            />
            <div v-if="item.message && item.message.length > 500">
              <span
                v-if="fullTextExtendedItemId !== index"
                class="toggle-text-button cursor-pointer"
                @click="showMoreContent(index)"
              >
                Ver más
                <i class="fas fa-chevron-down ml-1" />
              </span>
              <span
                v-else
                class="toggle-text-button cursor-pointer"
                @click="showMoreContent(index, false)"
              >
                Ver menos
                <i class="fas fa-chevron-up ml-1" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HistoryRow',
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fullTextExtendedItemId: -1,
    };
  },
  computed: {
    HTMLDynamicClass() {
      return ({ item, index }) => {
        let htmlClass = '';

        if (this.fullTextExtendedItemId !== index) htmlClass += ' shrank-text ';

        if (
          item.message &&
          item.message.length > 500 &&
          this.fullTextExtendedItemId === index
        )
          htmlClass += ' mb-5';

        return htmlClass;
      };
    },
  },
  methods: {
    showMoreContent(elementId, showMore = true) {
      if (showMore) {
        this.fullTextExtendedItemId = elementId;
        return;
      }
      this.fullTextExtendedItemId = -1;
      let el = document.getElementById(
        `contract-template-history-row-${elementId}`
      );
      const offsetScrollY = window.scrollY - 150;
      const yOffset = el.getBoundingClientRect().top + offsetScrollY;

      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

$skyBlue: #def7ee;
$skyBlueBorder: #b9edda;
$lightGray: #e2e2e2;

.history-container,
.container-wrapper {
  border-radius: 4px;
}
.container-wrapper {
  background-color: $skyBlue;
  border: 1px solid $skyBlueBorder;
}
.message-container {
  word-break: break-all;
}
.vertical-divider {
  border-right: 1px solid $lightGray;
}
.toggle-text-button {
  position: absolute;
  bottom: 8px;
  right: 16px;
  color: map-get($colors, 'green');
}
.shrank-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.margin-5 {
  margin-right: 1.5rem;
}
</style>
